import "@/sentry";
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/swRegister";
import { initGA } from "@/lib/ga";
import { initMetaPixel } from "@/lib/metaPixel";
import * as Sentry from "@sentry/react";

initGA();
initMetaPixel();

// Suppress cross-origin iframe errors (PostHog analytics vs PayPal iframe conflict)
// The error overlay from CRA dev server fires for cross-origin SecurityErrors
// which are harmless but block the user from interacting with PayPal buttons
const _sup = (e) => {
  const msg = e.message || (e.reason && e.reason.message) || '';
  if (msg.includes('cross-origin') || msg.includes('removeEventListener') || msg.includes('SecurityError')) {
    e.stopImmediatePropagation();
    e.preventDefault();
    // Also remove any CRA error overlay that may have appeared
    const overlay = document.getElementById('webpack-dev-server-client-overlay');
    if (overlay) overlay.style.display = 'none';
    return true;
  }
};
window.addEventListener('error', _sup, true);
window.addEventListener('unhandledrejection', (e) => {
  const msg = (e.reason && e.reason.message) || '';
  if (msg.includes('cross-origin') || msg.includes('SecurityError')) {
    e.stopImmediatePropagation();
    e.preventDefault();
    const overlay = document.getElementById('webpack-dev-server-client-overlay');
    if (overlay) overlay.style.display = 'none';
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={({ error }) => (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', textAlign: 'center', fontFamily: 'system-ui' }}>
        <div style={{ maxWidth: '480px' }}>
          <h1 style={{ fontSize: '20px', marginBottom: '12px' }}>Algo salió mal</h1>
          <p style={{ color: '#64748b', fontSize: '14px' }}>Nuestro equipo fue notificado. Por favor recarga la página.</p>
          <button onClick={() => window.location.reload()} style={{ marginTop: '16px', padding: '8px 16px', borderRadius: '8px', background: '#0891b2', color: 'white', border: 'none', cursor: 'pointer' }}>Recargar</button>
        </div>
      </div>
    )}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);

registerServiceWorker();
